"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z"];
//# sourceMappingURL=small-tick.js.map